import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import {
  BusquedaAsesorDialogComponent
} from '../../common/busquedas/busqueda-asesor-dialog.component';
import {
  BusquedaClienteDialogComponent
} from '../../common/busquedas/busqueda-cliente-dialog.component';
import { FiltrosInformacionTareasBridgeModule } from '../components/filtros-informacion-tareas/filtros-informacion-tareas.bridge.module';
import { TablaInformacionTareasComponent } from '../components/tabla-informacion-tareas/tabla-informacion-tareas.component';
import { InformacionTareasFacade } from '../services/informacion-tareas.facade';

/**
 * HU1 MVP3 - Informacion de Tareas.
 *
 * Legacy: InformacionTareasViewImpl / InformacionTareasActivity
 *
 * Container (Smart Component): orquesta el Facade y delega la presentacion
 * a los componentes dumb `FiltrosInformacionTareasComponent` y
 * `TablaInformacionTareasComponent` (skill componentes-reutilizables).
 */
@Component({
  selector: 'app-informacion-tareas',
  standalone: true,
  imports: [
    CommonModule,
    ToastModule,
    BusquedaAsesorDialogComponent,
    BusquedaClienteDialogComponent,
    FiltrosInformacionTareasBridgeModule,
    TablaInformacionTareasComponent
  ],
  providers: [MessageService, InformacionTareasFacade],
  template: `
    <div class="p-4 max-w-full mx-auto">
      <p-toast></p-toast>

      <app-filtros-informacion-tareas
        [oficinas]="facade.oficinas()"
        [esAsesor]="facade.usuarioState.esAsesor()"
        [consultando]="facade.consultando()"
        [filtroOrden]="facade.filtroOrden()"
        [fechaEntregaDesde]="facade.fechaEntregaDesde()"
        [fechaEntregaHasta]="facade.fechaEntregaHasta()"
        [filtroOficina]="facade.filtroOficina()"
        [nombreAsesor]="facade.nombreAsesor()"
        [nombreBeneficiario]="facade.nombreBeneficiario()"
        [tieneAsesorSeleccionado]="!!facade.asesorSeleccionado()"
        [tieneBeneficiarioSeleccionado]="!!facade.beneficiarioSeleccionado()"
        (filtroOrdenChange)="facade.filtroOrden.set($event)"
        (fechaEntregaDesdeChange)="facade.fechaEntregaDesde.set($event)"
        (fechaEntregaHastaChange)="facade.fechaEntregaHasta.set($event)"
        (filtroOficinaChange)="facade.filtroOficina.set($event)"
        (buscar)="facade.buscar()"
        (limpiar)="facade.limpiarFiltros()"
        (abrirBuscadorAsesor)="facade.abrirBuscadorAsesor()"
        (limpiarAsesor)="facade.limpiarAsesor()"
        (abrirBuscadorBeneficiario)="facade.abrirBuscadorBeneficiario()"
        (limpiarBeneficiario)="facade.limpiarBeneficiario()">
      </app-filtros-informacion-tareas>

      @if (facade.mostrarResultados()) {
        <app-tabla-informacion-tareas
          [items]="facade.items()"
          [consultando]="facade.consultando()"
          [pageSize]="facade.pageSize()"
          [totalRegistros]="facade.totalRegistros()"
          [registroInicio]="facade.registroInicio()"
          [registroFin]="facade.registroFin()"
          [currentPage]="facade.currentPage()"
          [totalPages]="facade.totalPages()"
          [hasNext]="facade.hasNext()"
          [hasPrevious]="facade.hasPrevious()"
          [pageSizeOptions]="facade.pageSizeOptions"
          [selectedPageSize]="facade.selectedPageSize()"
          (seleccionar)="facade.seleccionarOrden($event)"
          (cambiarTamanoPagina)="facade.onPageSizeChange($event)"
          (irPrimeraPagina)="facade.irPrimeraPagina()"
          (irPaginaAnterior)="facade.irPaginaAnterior()"
          (irPaginaSiguiente)="facade.irPaginaSiguiente()"
          (irUltimaPagina)="facade.irUltimaPagina()">
        </app-tabla-informacion-tareas>
      }

      @if (facade.dialogBuscarAsesorVisible()) {
        <app-asesor-search
          (onSelect)="facade.onAsesorSeleccionado($event)"
          (onClose)="facade.cerrarBuscadorAsesor()">
        </app-asesor-search>
      }

      @if (facade.dialogBuscarBeneficiarioVisible()) {
        <app-busqueda-cliente-dialog
          (onSelect)="facade.onBeneficiarioSeleccionado($event)"
          (onClose)="facade.cerrarBuscadorBeneficiario()">
        </app-busqueda-cliente-dialog>
      }
    </div>
  `
})
export class InformacionTareasComponent implements OnInit {
  readonly facade = inject(InformacionTareasFacade);

  ngOnInit(): void {
    this.facade.init();
  }
}
